import React from 'react';

function Issues() {
  return (
    <div>
      <h1>Issues Page</h1>
    </div>
  );
}

export default Issues;
